import { Box } from "@mantine/core"

export const STATUS_DOT_TONE = {
  success: "success",
  error: "error",
} as const

export type StatusDotTone =
  (typeof STATUS_DOT_TONE)[keyof typeof STATUS_DOT_TONE]

export type StatusDotProps = {
  readonly tone: StatusDotTone
}

const TONE_BACKGROUND: Record<StatusDotTone, string> = {
  success: "var(--mantine-color-success)",
  error: "var(--mantine-color-error-text)",
}

/**
 * Small semantic status indicator (success / error).
 */
export const StatusDot = ({ tone }: StatusDotProps) => {
  return (
    <Box
      w={8}
      h={8}
      bdrs="50%"
      bg={TONE_BACKGROUND[tone]}
      style={{ flexShrink: 0 }}
      aria-hidden
    />
  )
}
